module.exports = __webpack_public_path__ + "static/media/delete.78dadb6d.svg";